<template>
  <div class="metafield-edit-selection" :class="className">
    <p class="metafield__title">{{ field.label }} {{ title }}</p>

    <div class="metafield-edit-selection__content">
      <template v-if="subFormData.display === 'checkboxes'">
        <BaseCheckBox
          class="metafield-edit-selection__checkbox"
          v-for="option in subFormData.options"
          :key="option.value"
          :value="value ? Array.isArray(value) ? value : [value] : []"
          @input="onInput"
          :name="field.key"
          :optionValue="option.value"
          >{{ option.label }}</BaseCheckBox>
      </template>

      <template v-else-if="subFormData.display === 'radioboxes'">
        <BaseRadioBox
          class="metafield-edit-selection__radiobox"
          v-for="option in subFormData.options"
          :key="option.value"
          :value="value ? value : ''"
          @input="onInput"
          :name="field.key"
          :optionValue="option.value"
        >{{ option.label }}</BaseRadioBox>
      </template>

      <template v-else-if="subFormData.display === 'select-list'">
        <BaseSelect
          class="metafield-edit-selection__select"
          :options="subFormData.options"
          placeholder="Select an option..."
          :value="value"
          :name="field.key"
          @input="onInput"
          :showNullOption="true"
        ></BaseSelect>
      </template>
    </div>

    <TypographyInputHint v-if="hint">{{ hint }}</TypographyInputHint>
  </div>
</template>

<script>
import { forSingleMetafield } from '@/mixins/metafields-changed-detection.mixin'

export default {
  mixins: [ forSingleMetafield(true) ],
  props: {
    field: Object,
    value: [Array, String],
    subFormData: Object,
    hint: String
  },
  computed: {
    title () {
      const map = {
        'checkboxes': '(checkbox)',
        'select-list': '(list)',
        'radioboxes': '(radiobox)'
      }
      
      return map[this.subFormData.display]
    },
    className () {
      return {
        'metafield-edit-selection--horizontal-layout': !this.subFormData.verticalLayout
      }
    }
  },
  methods: {
    filterOutDeprecatedValues(val) {
      return val.filter(v => (this.subFormData.options || []).some(o => o.value === v))
    },
    onInput (val) {
      const emitValue = Array.isArray(val) ? this.filterOutDeprecatedValues(val) : val
      this.$emit('input', emitValue)
    }
  },
}
</script>

<style lang="scss">
  @import './src/assets/styles/mixins.scss';
  
  .metafield-edit-selection {
    display: block;

    .metafield__title {
      margin-bottom: 10px;
    }
    
    &__checkbox {
      display: block;
    }

    &__select {
      max-width: 305px;
    }

    &--horizontal-layout {

      .metafield-edit-selection {
        &__content {
          display: flex;
          flex-wrap: wrap;
        }

        &__checkbox, &__radiobox {
          
          &:not(:last-of-type) {
            margin-right: 30px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/metafields-edit/metafields/MetafieldEditSelection.vue